import { environment } from './../../../environments/environment';
import { AppActions } from './../../shared/store/app.reducer';
import { FiltersActions } from './../../shared/store/filters.reducer';
import { IState } from './../../shared/store/root.reducer';
import { BreadcrumbService } from './../../shared/services/breadcrum.service';
import { AuthService } from './../../shared/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-external-login',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.scss']
})
export class ExternalLoginComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private store: Store<IState>,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const guid = params['guid'];
      if (guid) {
        this.authService.loginExternal(guid).subscribe(res => {
          if (res) {
            const reidrectInfoParams = JSON.parse(res.Parameters);
            this.goToTarget(res.Url, reidrectInfoParams, res.userType);
          } else {
            window.location.href = environment.logoutRedirectUrl;
          }
        });
      } else {
        window.location.href = environment.logoutRedirectUrl;
      }
    });
    this.breadcrumbService.setBreadcrumb(this.activatedRoute);
  }

  private goToTarget(page: string, params: any, userType: number) {
    switch (page) {
      case 'app-navigation':
        if (userType === 2) {
          this.router.navigate(['partners']);
        } else {
         this.router.navigate(['shop/partners']);
        }
        break;
      case 'wizard':
        this.router.navigate(['wizard']);
        break;
      case 'find-partner':
        this.store.dispatch({
          type: FiltersActions.SET_SHOP_PARTNER_FILTER,
          payload: {
            supplierTypeId: params['supplierTypeId'],
            makeId: params['makeId']
          }
        });
        this.router.navigate(['shop/find-partners']);
        break;
      case 'partner':
         this.store.dispatch({
           type: FiltersActions.SET_SHOP_PARTNER_FILTER,
           payload: {
            supplierTypeId: params['supplierTypeId'],
            makeId: params['makeId'],
            dealerId: params['dealerId']
         }
         });
        this.router.navigate(['shop/partners']);
        break;
    }
  }
}
